import React, { useContext, useEffect, useState } from 'react';
import { useDebouncedCallback } from '../../../utils/useDebouncedCallback';
import { Button, Container, SearchInput } from '../../../components';
import CustomerTable from './CustomerTable';
import { IoMdAdd } from 'react-icons/io';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import CreateNewCustomer from './CreateNewCustomer';
import CustomerContext from '../../../context/customerContext/CustomerContext';

/**
 * CustomerView component displays the customer management interface.
 *
 * Features:
 * - Shows a searchable list of customers.
 * - Allows adding a new customer via a modal dialog.
 * - Uses debounced search input to filter customers.
 * - Fetches customer data on page or search query change.
 *
 * Contexts:
 * - Uses CustomerContext for customer data and actions.
 * - Uses useModal for modal management.
 *
 * @component
 */
const CustomerView = () => {
  const {
    clearFormData,
    setSearchQuery,
    currentPage,
    getAllCustomer,
    searchQuery,
  } = useContext(CustomerContext);

  // Local state for input value
  const [inputValue, setInputValue] = useState(searchQuery || '');
  const { openModal, closeModal } = useModal();

  const handleOpenModal = () => {
    clearFormData();
    openModal(<CreateNewCustomer closeModal={closeModal} />, 'Create Customer');
  };

  useEffect(() => {
    getAllCustomer();
  }, [currentPage, searchQuery]);

  // Debounced update to context
  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
  }, 400);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };

  return (
    <Container title="Customers">
      <div className="lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3 ">
        <SearchInput
          placeholder="Search Customers..."
          value={inputValue}
          onChange={handleSearchChange}
        />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button className="flex items-center" onClick={handleOpenModal}>
            <IoMdAdd className="mr-2" />
            Add Customer
          </Button>
        </div>
      </div>
      <CustomerTable />
    </Container>
  );
};
const App = () => (
  <ModalProvider>
    <CustomerView />{' '}
  </ModalProvider>
);
export default App;
